import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DropdownModule} from 'primeng/dropdown';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {TagModule} from 'primeng/tag';
import {TooltipModule} from 'primeng/tooltip';
import {MenuModule} from 'primeng/menu';
import {PrinterClientsDialogComponent} from './printer-clients-dialog.component';

@NgModule({
    declarations: [
        PrinterClientsDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        DropdownModule,
        DialogModule,
        ButtonModule,
        TagModule,
        TooltipModule,
        MenuModule
    ],
    exports: [
        PrinterClientsDialogComponent
    ]
})
export class SharedPrinterClientsModule { }
